import {register} from '@shopify/theme-sections';
import Swiper from 'swiper/bundle';

register('behind-the-scenes', {
  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const target = `#behind-the-scenes--${id}`;
    const swiper = new Swiper(target, {
      slidesPerView: 1,
      loop: true,
      freeMode: false,
      allowTouchMove: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
    });
    swiper.on('slideChange', () => {
      console.log('slide changed');
      // console.log(target.replace('#', ''));
      const videoEmbed = document
        .getElementById(target.replace('#', ''))
        .getElementsByClassName('wistia_embed');
      Array.prototype.forEach.call(videoEmbed, (videoLoad) => {
        // const videoHandle = videoLoad.getAttribute('data-video-handle');
        // console.log(`Slider video: ${videoId}`);
        window._wq = window._wq || [];
        _wq.push({
          id: '_all',
          onReady(video) {
            console.log('Stop video');
            video.pause();
          },
        });
      });
    });
  },
});
